import styled from 'styled-components';

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #fff;
  background-color: ${({ $color }) => $color};
`;
